define([
        'text!./templates/language-expandos.html'
    ],
    (templateStr)=> {
        /**
         * Widget for displaying language expandos
         */
        return ()=> {
            return {
                restrict: 'A',
                replace: true,
                template: templateStr,
                controller: ['$scope', 'LocaleService',
                    ($scope, LocaleService)=> {
                        $scope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
                        $scope.localesDisplayNames = LocaleService.getLocalesDisplayNames();
                        $scope.isVisible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;
                        $scope.isOpen = false;

                        // METHODS
                        $scope.changeLanguage = (locale)=> {
                            LocaleService.setLocaleByDisplayName(locale);
                            $scope.currentLocaleDisplayName = locale;
                        };
                        $scope.toggleExpandos = ()=> {
                            $scope.isOpen = !$scope.isOpen;
                        };
                    }
                ]
            };
        };
    });



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/l10n/directives/LanguageExpandosDirective.js
 **/